import type { AssistantActivity } from '@secretario/shared';

export type AssistantChoice = NonNullable<AssistantActivity['choices']>[number];

/** As opções que o Secretário ofereceu nesta resposta (ex.: as unidades de uma rede). */
export function choicesOf(activities: AssistantActivity[]): AssistantChoice[] {
  const seen = new Set<string>();
  return activities
    .flatMap((activity) => activity.choices ?? [])
    .filter((choice) => {
      const key = choice.lugar ?? choice.send;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    })
    .slice(0, 6);
}

/**
 * Responder com um toque: cada opção é um botão com o nome e o endereço. O toque manda a
 * escolha como fala da pessoa (com o id da unidade), e a conversa segue sem digitar.
 */
export function ChoiceButtons({
  choices,
  disabled,
  onPick,
}: {
  choices: AssistantChoice[];
  disabled?: boolean;
  onPick: (choice: AssistantChoice) => void;
}) {
  if (choices.length === 0) return null;
  return (
    <div className="ch-list" role="group" aria-label="Escolha uma opção">
      {choices.map((choice) => (
        <button
          key={choice.lugar ?? choice.send}
          type="button"
          className="ch-item"
          disabled={disabled}
          onClick={(event) => {
            event.stopPropagation();
            onPick(choice);
          }}
        >
          <span>
            <b>{choice.label}</b>
            {choice.sub && <small>{choice.sub}</small>}
          </span>
          <i aria-hidden="true">›</i>
        </button>
      ))}
    </div>
  );
}
